import { csrfToken } from "@/lib/orderActions"

// Transport for the Request-a-sample form (UPDA-74). Mirrors
// lib/freelancerInvitations.js — session-auth JSON over the cookie, never the
// JWT-only /api/v1 routes.

// A refusal may carry `finishProfile`, the page that unblocks it (Clear passage).
async function jsonResponse(response, fallback) {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw Object.assign(new Error(data.error || fallback), { finishProfile: data.finishProfile })
  return data
}

export async function loadSampleOptions(slug, { signal } = {}) {
  const response = await fetch(`/freelancers/${encodeURIComponent(slug)}/sample`, {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
    signal,
  })
  return jsonResponse(response, "We couldn't open that sample request.")
}

export async function priceSampleDiscount(slug, code, { signal } = {}) {
  const query = new URLSearchParams({ code })
  const response = await fetch(
    `/freelancers/${encodeURIComponent(slug)}/sample/discount?${query}`,
    { headers: { Accept: "application/json" }, credentials: "same-origin", signal }
  )
  return jsonResponse(response, "We couldn't apply that code.")
}

export async function sendSampleRequest(slug, sample) {
  const response = await fetch(`/freelancers/${encodeURIComponent(slug)}/sample`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify({ sample }),
  })
  return jsonResponse(response, "We couldn't send that request.")
}
